import { Badge } from 'antd'

import type { FulfillmentOrderDisplayStatusRoot, FulfillmentOrderCountsRoot } from '@repo/sdk'

import type { FoStatusConfig } from './foDisplayStatusConfig'
import { DISPLAY_STATUSES } from './orderDisplayStatuses'

function toCountMap(
  counts: FulfillmentOrderCountsRoot,
): Record<FulfillmentOrderDisplayStatusRoot, number> {
  return {
    PAYMENT_PENDING: counts.paymentPending,
    AWAITING_REPAYMENT: 0,
    PAID: counts.paid,
    SHIPPED: counts.shipped,
    DELIVERED: counts.delivered,
    CONFIRMED: counts.confirmed,
    ALL_CANCELLED: counts.allCancelled,
    ALL_RETURNED: 0,
  }
}

export function createOrderTabItems(
  statusConfig: FoStatusConfig,
  counts: FulfillmentOrderCountsRoot,
) {
  const countMap = toCountMap(counts)

  return DISPLAY_STATUSES.map((status) => ({
    key: status,
    label: (
      <span data-testid={`order-list-tab-${status.toLowerCase().replace(/_/g, '-')}`}>
        {statusConfig[status].label}{' '}
        <Badge count={countMap[status]} showZero={false} overflowCount={999} />
      </span>
    ),
  }))
}
